import { computed, toValue } from "vue";

export function useDateSelectorPlacement({ placement, catalogsReady, settings, payload, view, mobile }) {
  const placementForScreen = computed(() => {
    const result = payload.value;
    const directory = settings.value?.result?.resultTemplate === "directory";
    if (!catalogsReady.value || !result?.appointment_grid || directory) {
      return undefined;
    }
    if (!result.show_open_scheduling || result.slots_ui === "cards") {
      return undefined;
    }
    if (mobile.value) {
      return "list";
    }
    return view.value === "map" ? "map" : "header";
  });
  const visible = computed(() => placementForScreen.value === toValue(placement));
  const display = computed(() => (visible.value ? "block" : "none"));

  return { visible, display };
}
